import * as React from 'react';
import { Menu } from 'antd';

import HasPermissions from '../HasPermissions';

const MenuWithPermissions = ({ children, userPermissions = [], ...props }) => {
    const processChildren = (items) => {
        const processedItems = [];

        React.Children.forEach(items, (child) => {
            if (!React.isValidElement(child)) {
                return;
            }

            if (child.type === HasPermissions) {
                const menuChild = child.props.children;
                if (React.isValidElement(menuChild)) {
                        processedItems.push(React.cloneElement(menuChild));
                }           
            } else {
                processedItems.push(child);
            }
        });

        return processedItems;
    };
    const renderedChildren = processChildren(children);

    return (
        <Menu {...props}>
            {renderedChildren}
        </Menu>
    );
}; 

export default MenuWithPermissions;